import { TranslationFunctionType } from '@/common/types';
import { object, string } from 'yup';

export const redirectPageTemplateSchema = (t: TranslationFunctionType) =>
  object({
    name: string().required(t('error.requiredField')),
  });
